var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isEditModalOpen)?_c('div',{staticClass:"update-status-modal"},[_c('div',{staticClass:"modal-content"},[_c('span',{staticClass:"close-btn",on:{"click":_setup.close}},[_vm._v("×")]),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }